export default __webpack_public_path__ + "static/media/6.0050be23.jpg";